import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, RegistrationDto, TransferRegistrationDto, UserServiceProxy, } from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'transferToAnotherUserModal',
    templateUrl: './transfer-to-another-user-modal.component.html'
})

export class  TransferToAnotherUserModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal') modal: ModalDirective;    
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;
    
    registration: RegistrationDto = new RegistrationDto();
    users = [];
    user = undefined;

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy,
        private _userService: UserServiceProxy
    ) {
        super(injector);        
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }
    
    close(): void {
        this.active = false;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();        
    }    

    public show(registration: RegistrationDto): void {        
        
        this.active = true;                
        this.users = [];
        this.user = undefined;   
        this.registration = registration;  

        this.modal.show();
    }    

    save(): void {
          
        let msg = this.l('Are you sure transfer to another user the registration of the {0}?', this.registration.user.name);

        let input = new TransferRegistrationDto()
        input.registrationId = this.registration.id;
        input.userId = this.user.id;

        this.message.confirm(
            msg,
            (isConfirmed) => {
            if (isConfirmed) {
                    this._registrationsService.transferToAnotherUser(input)
                    .subscribe(() => {
                        this.notify.info(this.l('SavedSuccessfully'));
                            this.close();
                            this.modalSave.emit(null);
                    });
                }
            }
        );
    }

    // Get Users
    filterUsers(event): void {
        this._userService.getUsersForSelect(
            event.query,
            undefined,
            20,
            0)
        .subscribe(result => {
            this.users = result.items;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/transfer-to-another-user/transfer-to-another-user-modal.component.ts